import RTE from '@/rte'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: null,
    isLoggedIn: false,
    tokenDetail: null,
    userInfo: null,
    applicationFilter: null
  },

  mutations: {
    clear() {
      //
      // Note we don't clear apiUrl
      //
      this.state.isLoggedIn = false;
      this.state.tokenDetail = null;
      this.state.userInfo = null;

      localStorage.clear();
    },

    initialize(state) {
      state.apiUrl = RTE.getApiURL();
      console.log("Initialized API URL to '" + state.apiUrl + "'");
    },

    setToken(state, token) {
      if (token) {
        state.isLoggedIn  = true;
        state.tokenDetail = token;

        //
        // We're still going to save this in local storage so users could
        // send this for debugging purposes
        //
        localStorage.setItem('token', JSON.stringify(token));
      } else {
        this.dispatch('clear');
      }
    },

    setUserInfo(state, userInfo) {
      if (userInfo) {
        state.userInfo = userInfo;
      } else {
        state.userInfo = null;
      }
    },

  },

  actions: {
    initialize(context) {
      context.commit('initialize');
    },
    clear(context) {
      context.commit('clear');
    },
    setToken(context, payload) {
      context.commit('setToken', payload.payload);
},
    setUserInfo(context, payload) {
      context.commit('setUserInfo', payload.payload);
    },

  },

  modules: {}
})
